var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42465",
    "data-name": "Group 42465",
    transform: "translate(-396 -192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document_5_",
    "data-name": "document (5)",
    transform: "translate(396 192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11803",
    "data-name": "Path 11803",
    d: "M25.7,9.3l-7-7A.908.908,0,0,0,18,2H8A2.006,2.006,0,0,0,6,4V28a2.006,2.006,0,0,0,2,2H24a2.006,2.006,0,0,0,2-2V10A.908.908,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.006,2.006,0,0,0,2,2h6Z",
    transform: "translate(0 0)",
    fill: "#0082a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18601",
    "data-name": "Rectangle 18601",
    width: 12,
    height: 2,
    transform: "translate(10 22)",
    fill: "#0082a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18602",
    "data-name": "Rectangle 18602",
    width: 12,
    height: 2,
    transform: "translate(10 16)",
    fill: "#0082a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18603",
    "data-name": "Rectangle 18603",
    width: 32,
    height: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 2.667,
    cy: 2.667,
    r: 2.667,
    transform: "translate(419.924 192.152)",
    fill: "#e80000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.06ca08fb695d3b1fdd20e4046d083022.svg";
export { ForwardRef as ReactComponent };